import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { CommonUtil } from '../../core/Utils/common-util';
import { ResetPasswordService } from '../services/reset-password.service';
import { ToastMessageService } from '../../core/shared-service/toast-message.service';

import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  rootScopeData: RootScopeDeclare;
  resetPasswordForm: FormGroup;
  submitted = false;
  showModal = false;
  constructor(public commonUtil: CommonUtil,
    private resetPasswordService: ResetPasswordService,
    private router: Router,
    private toastMessageService: ToastMessageService,
    private fb: FormBuilder,
    private rootScopeService: RootScopeService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService) {
    this.getRootScopeData();
    this.rootScopeData.pageName='ResetPassword';
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  ngOnInit() {
    this.resetPasswordForm = this.fb.group({
      email: ['', Validators.compose([
        Validators.required,
        Validators.pattern(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+[.][A-Za-z]{2,50}$/)]
      )]
    });
  }

  get emailvalidator() {
    return this.resetPasswordForm.controls;
  }

  cancelResetPassword(): void {
    //need to add cancel modal
    if (!this.emailvalidator.email.pristine) {
      this.openModal();
      return;
    }
    this.router.navigate(['/login']);

  }

  submitResetPassword(): void {
    this.submitted = true;
    if (this.resetPasswordForm.dirty && this.resetPasswordForm.valid) {      
      this._amplitudeAnalytics.logEvent({elementName: 'Submit', action: "Click"});
      this.resetPasswordService.post(this.emailvalidator.email.value)
        .subscribe(
          response => {
            if (response.status == 200) {
              //need to remove the error field class from input
              this.toastMessageService.emitChange(this.commonUtil.translateText('FORGOT.PASSWORD.MSG'));
              this.router.navigate(['/landing']);              
            }
          },
          error => {
            console.error('Error');
          }
        );
    }
  }

  openModal(): void {
    this.showModal = true;
  }

  onPositiveConfirmation(): void {
    this.closeModal();
    this.router.navigate(['/login']);
  }

  closeModal(): void {
    this.showModal = false;
  }

}
